"use strict";

export class Stopwatch {
    constructor(autostart) {
        this._time = 0;
        this._startTime = 0;
        this._started = false;

        if (autostart) {
            this.start();
        }
    }

    get time() { return this._time; }

    start() {
        if (this._started) return;
        this._time = 0;
        this._startTime = Time.now;
        this._started = true;
    }

    stop() {
        if (!this._started) return;
        this._time = Time.now - this._startTime;
        this._started = false;
    }
}